import OutlineEight from '@assets/icons/outline-eight.svg'
import { Icon } from './Icon'

export const OutlineEightIcon = Icon(OutlineEight)
